import React, { useState, useEffect } from 'react';
import Notifications from '../../services/Notifications';
import { withStorefrontConfig } from '../../hooks/StorefrontSettingsContext';
import Loading from '../Loading';
import UserService from '../../services/UserService';
import Typography from '@mui/material/Typography';
import Autocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Popper from '@mui/material/Popper';
import Checkbox from '@mui/material/Checkbox';
import Api from '../../services/Api';
import { CircularProgress } from "@mui/material";

const Clone = ({
    user,
    usersToClone,
    updateUsersToClone,
    setUsersToClone,
    isRoleClone,
    setIsRoleClone,
    StorefrontConfig
}) => {
    const [customers, setCustomers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState(updateUsersToClone || []);
    const [optionUsers, setOptionUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        const fetchCustomers = async () => {
            await UserService.getCustomers(user.id, setCustomers);
        };
        fetchCustomers();
        setOptionUsers(usersToClone);
    }, [user.id]);

    const handleClonedUsersChange = (e, values) => {
        const ids = values.map(x => x.id);
        setSelectedUsers(ids);
        setUsersToClone(ids);
    };
    const updateOptions = async (e, values) => {
        if (e.target.value == '') {
            setOptionUsers(usersToClone);
        } else {            
            if ((e.target.value.length > 3) && (!optionUsers.some(user => user.email.toLowerCase().includes(e.target.value.toLowerCase())))) {
                setLoading(true);
                const fetchedUsers = await Api.fetch('/api/user/list?top=100&skip=0&orderBy=lastName&personas=*&search=' + e.target.value);
                setOptionUsers(fetchedUsers);
                setLoading(false);
            }
        }
    }
    if (!StorefrontConfig.storefrontSettingsLoaded) {
        return <Loading type="brand" />;
    }

    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'center', width: 'fit-content' }}>
                <Box>
                    <Typography variant="h4" style={{ marginLeft: "10px" }}>{user.email}</Typography>
                    <Typography variant="h5" style={{ marginLeft: "10px" }}>{"Customers: " + customers.length}</Typography>
                </Box>
                <Box>
                    <Typography variant="h5" style={{ marginLeft: "10px", marginTop: "15%" }}>
                        {"Secondary Email: "} {user.secondaryEmail || "N/A"}
                    </Typography>
                </Box>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'center', width: 'fit-content' }}>
                <Box>
                    <Typography variant="h6" sx={{ marginTop: "5px", fontWeight: "bold" }}>Clone Permissions</Typography>
                </Box>
                <Box>
                    <Checkbox
                        onChange={setIsRoleClone}
                        checked={isRoleClone}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />
                </Box>
            </Box>

            <br /><br />
            <Autocomplete
                multiple
                id="tags-standard"
                size="lg"
                disablePortal
                PopperComponent={(props) => (
                    <Popper {...props} placement="bottom-start">
                        {props.children}
                    </Popper>
                )}
                loading={loading}        
                options={optionUsers}
                getOptionLabel={(option) => option.email}
                renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => (
                        <Chip
                            label={option.email}
                            {...getTagProps({ index })}
                            sx={{
                                background: 'white',
                                color: 'black',
                                fontSize: "15px",
                                height: "100%",
                                width: '100%',
                                padding: "10px"
                            }}
                        />
                    ))
                }
                onChange={handleClonedUsersChange}
                onInputChange={updateOptions}
                defaultValue={selectedUsers}
                loadingText="Loading users..."
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder="Clone To"
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {loading ? <CircularProgress size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                        }}
                    />
                )}
            />
        </>
    );
};
function notValid(message) {
    Notifications.error(message);
    return false;
}
export default withStorefrontConfig(Clone);